<template>
  <div style="position: fixed; top: 0; left: 0; right: 0; display: block; width: 100vw; height: 48px;">
    <div style="background-color: #FFFFFF; height: 100vh"></div>
  </div>


  <PageUnavailable v-if="page_unavailable" />
  <router-view v-else-if="ready" />
  <Relocationdialog v-if="relocation_dialog == true && ready == true" :key="moved_enroll.confirmation_reference"
    :enroll="moved_enroll" v-model="relocation_dialog" @close-dialog="nextMovedEnroll" />

  <ConnectCalendarDialog v-else-if="connect_dialog == true && ready == true && checkCalendar" v-model="connect_dialog"
    @close-dialog="connect_dialog = false" />
  <ConnectedCompanyPageDialog v-else-if="connected_company_dialog == true && ready == true"
    v-model="connected_company_dialog" @close-dialog="() => {
      connected_company_dialog = false;
      $router.replace({
        query: {
          ...this.$route.query,
          register: undefined,
        },
      });
    }" />
</template>

<script>
const cookies = require("js-cookie");

import api from "./services/api";
import config from "./config/index";
import { useMainStore } from "./stores/store";
import { withReturnParam } from "./util/returnPath";
import Relocationdialog from "./components/relocation_dialog.vue";
import ConnectCalendarDialog from "./components/connect_calendar_dialog.vue";
import ConnectedCompanyPageDialog from "./components/dialogs/connectedCompanyPageDialog.vue";
import PageUnavailable from "./components/page_unavailable.vue";

export default {
  components: {
    Relocationdialog,
    ConnectCalendarDialog,
    ConnectedCompanyPageDialog,
    PageUnavailable,
  },
  data: () => ({
    ready: false,
    page_unavailable: false,
    relocation_dialog: false,
    calendar_connected: false,
    connect_dialog: true,
    connected_company_dialog: false,

    isPublicPage: false,
    mainstore: useMainStore(),
    // Elke nog niet beantwoorde verplaatsing, oudste eerst; ze worden een voor
    // een afgewerkt. Eén tegelijk tonen en de rest laten wachten kostte de
    // tweede boeking: die verliep terwijl hij nooit in beeld kwam.
    moved_enrolls: [],
    moved_enroll: {
      content: {
        nl: {},
        eng: {},
      },
    },
  }),

  beforeMount() {
    const subdomain = location.hostname.split(".", 1)[0];
    const config_login = config.url.login.replace("{{domain}}", subdomain) + "/inloggen";
    const currentPath = location.pathname;
    const queryString = location.search;
    const hasAuthToken =
      !!cookies.get("fmw_refresh_token") || !!cookies.get("fmw_access_token");


    const isLoginHost =
      location.hostname === "localhost" ||
      location.hostname.endsWith(".localhost") ||
      location.hostname === "staging-app.nl" ||
      location.hostname === "inloggen.staging-app.nl" ||
      location.hostname === "dfm-app.nl" ||
      location.hostname === "inloggen.dfm-app.nl" ||
      location.hostname === "connect.dfm-app.nl" ||
      location.hostname === "connect.staging-app.nl" ||
      location.hostname === "inloggen.test.local"; // for testing purposes

    this.isPublicPage = [
      "/inloggen",
      "/otp",
      "/registreren",
      "/welcome",
      "/registratie-voltooien",
      "/wachtwoord-wijzigen",
      "/wachtwoord-vergeten",
      "/openbare-pagina",
      // De Specialistlink draagt zijn eigen autorisatie in de URL. De trailing
      // slash houdt hem tot /link/:token.
      "/link/",
      // De Share link bewaakt zijn eigen toegang, net als /formulier: de
      // template toetst het token en stuurt zelf door naar de OTP-login. Als
      // gewone app-pagina ging een bezoeker zonder sessie naar /bedrijfspagina
      // terwijl die toets nog liep, en las de template daarna een token uit
      // een route die er niet meer was: linkformulier=undefined.
      "/linkformulier/",
      "/review",
      "/afspraak-bevestigen",
      // De uitnodigingslink beslist zelf of je moet inloggen of registreren,
      // en onthoudt zichzelf daarbij als Terugkeerpad (ClickUp 86c47j3zm).
      "/uitnodiging/",
      "/formulier",
      "/bedrijfspagina",
    ].some((prefix) => currentPath.startsWith(prefix));

    // Set default styling for login pages
    if (isLoginHost) {
      this.setCompanyPrimaryColor("#E5007D");

      if (
        location.hostname === `inloggen.${config.base_domain}` &&
        !currentPath.startsWith("/inloggen")
      ) {
        location.replace(`${config_login}${queryString}`);
        return;
      }

      this.ready = true;
      return;
    }

    // Handle regular app pages
    if (!this.isPublicPage) {
     
      if (hasAuthToken) {

      api
          .get(`/v1/users/me/info`)
          .then((res) => {
            const mainStore = useMainStore();
            mainStore.$patch({ user: res.data });

            if (res.data.language) {
              this.$i18n.locale = res.data.language;
            }

            if (res.data.moved_enroll) {
              // De API gaf vroeger één object terug en geeft nu een lijst.
              this.moved_enrolls = Array.isArray(res.data.moved_enroll)
                ? [...res.data.moved_enroll]
                : [res.data.moved_enroll];
              this.nextMovedEnroll();
            }

            const queryParams = new URLSearchParams(queryString);
            if (
              queryParams.get("register") == "true" ||
              queryParams.get("register") == true
            ) {
              this.connected_company_dialog = true;
            }

          })
        }
        
            api.get(`/v1/pages/${subdomain}`).then((res) => {
            const page = res.data.success;
            this.setCompanyPrimaryColor(page.style.primary_color);
            useMainStore().$patch({ companypage: page });

            if (!this.$i18n.locale) {
              this.$i18n.locale =
                page.preferred_language === "eng" ? "en" : "nl";
            }

         

            this.ready = true;
             if(!hasAuthToken){
            this.$router.replace("/bedrijfspagina");

          }
          })
        
      .catch((error) => {
        // 401/404 on /v1/pages/:subdomain means the Bedrijfspagina itself is
        // gone or closed to this user — PageService answers 401 for both, to
        // logged-in and logged-out callers alike. Logging in cannot change that
        // answer, so the deeplink is dead: say so, and neither wipe a session
        // that is still valid elsewhere nor bounce the user to a login screen
        // that would only send them back here. See ClickUp 86cb4amq4.
        //
        // This is checked before the "/" fallback below, because /bedrijfspagina
        // resolves the very same page and would only spin its loader forever.
        //
        // `ready` stays false on purpose: it also gates the three dialogs below,
        // which have nothing to say on a page that does not exist.
        if (this.isPageGone(error)) {
        // The dead page never supplied a colour, and --company-primary has no
        // stylesheet default: without this the screen's own button is white on
        // white.
        this.setCompanyPrimaryColor("#E5007D");
        this.page_unavailable = true;
        return;
      }

        if(currentPath == '/'){
        this.$router.replace("/bedrijfspagina");
        this.ready = true;
        return;
      }
      else {
      this.forceLogout(config_login, queryString, true);
    }

    })
  
    } else {
      if (!["dfm-app.nl", "inloggen.dfm-app.nl", "staging-app.nl", "inloggen.staging-app.nl"].includes(location.hostname)) {
        api
          .get(`/v1/pages/${subdomain}`)
          .then((res) => {
            const page = res.data.success;
            // Twee paletten, een route (ADR-0063): de specialistlink rendert in
            // DFM-kleuren, want de kijker werkt voor DFM en niet voor de klant.
            // De klant wordt benoemd door een kaart met zijn logo, niet door de
            // shell -- vandaar dat de pagina zelf wel geladen blijft.
            this.setCompanyPrimaryColor(
              currentPath.startsWith("/link/") ? "#E5007D" : page.style.primary_color
            );
            useMainStore().$patch({ companypage: page });

            this.$i18n.locale = page.preferred_language === "eng" ? "en" : "nl";
            this.ready = true;
           
          })
          .catch(() => {
            // A public page — /inloggen above all — does not need the
            // Bedrijfspagina: it only supplies theming and the preferred
            // language. Redirecting to the login screen *from* the login screen
            // is a location.replace onto the current URL, i.e. an endless
            // reload, which is exactly what a dead subdomain used to produce.
            // See ClickUp 86cb4amq4.
            this.setCompanyPrimaryColor("#E5007D");
            this.ready = true;
          });
      }
    }
  },

  computed: {
    checkCalendar() {
      if (this.isPublicPage) {
        return false;
      } else if (!this.mainstore.companypage.calendar_integration) {
        return false;
      } else if (!this.mainstore.user.notifications["calendar_popup"]) {
        return false;
      } else if (this.mainstore.user.updating_role === "employer") {
        return false;
      } else {
        return true;
      }
    },
  },
  methods: {
    // Toon de volgende openstaande verplaatsing, of sluit af als er geen meer
    // is. Ook de sluit-handler van de dialog: wie er een afhandelt, krijgt
    // meteen de volgende te zien in plaats van bij een volgende keer inloggen.
    nextMovedEnroll() {
      const next = this.moved_enrolls.shift();

      if (!next) {
        this.relocation_dialog = false;

        return;
      }

      this.moved_enroll = next;
      this.relocation_dialog = true;
    },
    // True when /v1/pages/:subdomain answered "this Bedrijfspagina is not
    // available to you" rather than "the request failed". A transient 5xx or a
    // network drop must NOT be read as a deleted page — that would replace a
    // deploy blip with a permanent-looking error screen.
    isPageGone(error) {
      const status = error && error.response ? error.response.status : null;

      return status === 401 || status === 404;
    },
    setCompanyPrimaryColor(color) {
      const newColor = color ? color : "#e5007d";
      const secondaryColor = color == "#e5007d" ? '#00BCEE' : newColor;
      // Set the hex variable
      document.documentElement.style.setProperty("--company-primary", newColor);
      document.documentElement.style.setProperty("--company-secondary", secondaryColor);

      // Convert hex to RGB
      const hex = newColor.replace("#", "");
      const r = parseInt(hex.substring(0, 2), 16);
      const g = parseInt(hex.substring(2, 4), 16);
      const b = parseInt(hex.substring(4, 6), 16);

      // Set the RGB variable
      document.documentElement.style.setProperty(
        "--company-primary-rgb",
        `${r}, ${g}, ${b}`,
      );
      const hexSecondary = secondaryColor.replace("#", "");
      const rSecondary = parseInt(hexSecondary.substring(0, 2), 16);
      const gSecondary = parseInt(hexSecondary.substring(2, 4), 16);
      const bSecondary = parseInt(hexSecondary.substring(4, 6), 16);
      document.documentElement.style.setProperty(
        "--company-secondary-rgb",
        `${rSecondary}, ${gSecondary}, ${bSecondary}`,
      );
    },
    // `keepReturnPath` is opt-in, not the default. The /v1/pages/:subdomain
    // catch now only reaches here for a transient failure — a page that is
    // really gone renders the unavailable screen instead — so returning the
    // user to their deeplink after login is safe there. See docs/adr/0028.
    forceLogout(redirectUrl, queryString, keepReturnPath = false) {
      const opts = { domain: config.cookiedomain, path: "/" };
      cookies.remove("fmw_access_token", opts);
      cookies.remove("fmw_refresh_token", opts);
      cookies.remove("user", opts);

      // The flat query is INPUT to the login screen (token/register feed
      // /v1/auth/step); `r` is where to go afterwards. Both, kept separate.
      const target = `${redirectUrl}${queryString}`;
      const destination = keepReturnPath
        ? withReturnParam(target, location.pathname, location.search)
        : target;

      // Never replace the current URL with itself. location.replace() onto the
      // page you are already on is a reload, and the reload runs this same
      // beforeMount again — one dead Bedrijfspagina spun here forever
      // (ClickUp 86cb4amq4). Render whatever the route resolves to instead.
      if (this.isCurrentUrl(destination)) {
        this.ready = true;
        return;
      }

      location.replace(destination);
    },
    isCurrentUrl(url) {
      try {
        return new URL(url, location.href).href === location.href;
      } catch (err) {
        // Unparseable target: let the navigation happen and fail visibly.
        return false;
      }
    },
  },
};
</script>

<style>
.text-company-primary {
  color: var(--company-primary) !important;
}
</style>
